<div class="modal-content" data-testid="SUBSYS5_LOADER_BOX">
	<img data-testid="SUBSYS5_LOADER_IMG" [src]="LOADER_URL" alt="loading" class="logo-loading">
</div>